export default __webpack_public_path__ + "static/media/26.3bb442b8.pdf";